import {
  addDoc,
  deleteDoc,
  getDocs,
  orderBy,
  where,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import {
  getDepartmentsRef,
  getPackageRef,
  getPackagesCollectionRef,
} from "../../../firebase/collectionReferences";

// export async function getDepartments(userId, keyword = null) {
//   const userRef = getUserRef(userId);
//   const departmentsRef = getDepartmentsCollectionRef(userRef);
//   const departmentsQuery = query(departmentsRef, where("userId", "==", userId));
//   const departments = await getDocs(departmentsQuery);

//   return departments.docs.map((x) => ({ ...x.data(), id: x.id }));
// }

export async function deletePackage(packageId) {
  const packageRef = getPackageRef(packageId);
  await deleteDoc(packageRef);
}

export async function addPackage(data) {
  const departmentsRef = getPackagesCollectionRef();
  const department = await addDoc(departmentsRef, {
    ...data,
    createdAt: serverTimestamp(),
  });
  return department.id;
}

export async function updatePackage(data) {
  const packageRef = getPackageRef(data.id);
  await updateDoc(packageRef, data);
  return data.id;
}

export const getPackageByField = async (key, value) => {
  const packageRef = getPackagesCollectionRef();
  const packageQuery = query(packageRef, where(key, "==", value));
  const packageDocs = (await getDocs(packageQuery)).docs.map((row) => ({
    ...row.data(),
    id: row.id,
  }));

  if (packageDocs.length === 1) {
    return packageDocs[0];
  } else {
    return {};
  }
};
